
export const CARACTERES_SPECIAUX = `#?!@$%^&*-`;
export const PASSWORD_MIN_CHAR_UTILISATEUR = 8;
export const PASSWORD_MIN_CHAR_ADMIN = 12;

export const REGEX_UTILISATEUR_PASSWORD = `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[${CARACTERES_SPECIAUX}]).{${PASSWORD_MIN_CHAR_UTILISATEUR},}$`;
export const REGEX_ADMIN_PASSWORD = `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[${CARACTERES_SPECIAUX}]).{${PASSWORD_MIN_CHAR_ADMIN},}$`;

export const REGEX_MAIL_SGP = `^.*@sgp.fr$`;

export const REGEX_SIREN = `^[0-9]{9}$`;
export const REGEX_SIRET = `^[0-9]{14}$`;
export const REGEX_INTEGER = `^[0-9 ]*$`;

export const REGEX_CODE_ROME = `^[A-Z][0-9]{4}$`;